import {  Heading, Flex, VStack, Button, Show, Divider } from '@chakra-ui/react';
import React from 'react';
import { useTheme } from '@chakra-ui/react';
import Contacts from '../modules/Contacts';

const Footers = () => {

  const theme = useTheme();
  const Year = new Date().getFullYear(); 


    const EmailButtonClicked = () => {
      const emailSubject = 'Inquiry about ';
      const emailBody = `
      Hi Ayaan,

      `;
    
      const mailtoUrl = `mailto:ayaanishere08@gmail.com?subject=${encodeURIComponent(emailSubject)}&body=${encodeURIComponent(emailBody)}`;
      window.open(mailtoUrl, "_blank");
    }


  return (

    <Flex 
      wrap="wrap"
      w="100%"
      id="footer"
      as="footer" 
      bg={'transparent'}  
      color='white'>
        <VStack  
            px={{base: '1em', md: '2em', lg: '4em'}}
            w="100%" >
          <VStack w={{base: '100%',md: '100%',lg: '100%'}} 
          py="0.5em">
            
          <Heading fontSize={{ base: "30px", md: "36px", lg: "36px" }}
                    fontWeight={600}
                    fontFamily={theme.font.secondary}
                    color={theme.colors.primary}
                    py={'0.3em'} >Get in Touch.</Heading>
          <Heading fontSize={{ base: "20px", md: "24px", lg: "24px" }}
                    fontWeight={'semi-bold'}
                    overflow={'hidden'}
                    align={'center'}
                    wordBreak={'keep-all'}
                    overflowWrap={'break-word'}
                    fontFamily={theme.font.secondary}
                    color={theme.colors.secondText}
                    px={'1.5em'}
                    py={'0.5em'}>
                    I am currently looking for full-time opportunities in Dubai or Abu Dhabi, starting in January
          </Heading>
          
          <Button onClick={EmailButtonClicked} 
          color="white"
          size='md'
          p={'1.2em'}
          colorScheme='teal'
          bg = {theme.colors.secondary}
          fontSize={'20px'}>
            Say Hello
          </Button>
          </VStack>

          <Show breakpoint='(max-width: 800px)'
          >
            <Contacts colors={theme.colors.primary} />
          </Show>

        </VStack>

       

        <VStack w="100%" p="1.5em" justifyContent={'center'}>
          <Divider w={'25%'}  
          borderWidth="1px"
          borderColor={theme.colors.primary}
            />
          <Heading fontSize={{base: '16px',md: '18px',lg: '18px'}} 
          fontFamily={theme.font.secondary}
          color={theme.colors.primary}
          align={'center'}
          > Designed and built by &copy;  {Year} Ayaan Ahmad</Heading>
        </VStack>

    </Flex>
  )
}

export default Footers